module.exports = __webpack_public_path__ + "static/media/bug.fdebb6c5.svg";